
// alert("5555")
class PlayVideo {
  constructor() {
    this.init();
  }
  init = () => {
    this.clickEvents();
  };
  clickEvents = () => {
    let play = qsa(".video-wrapper .initial-img",this.parent);
    if(play.length > 0) {
      play.forEach(item => {
        item.addEventListener("click",e => {
          item.parentNode.querySelector(".video-frame").classList.remove("d-none");
          item.classList.add("d-none");
        })
      });
    }
  }
}
if(qs(".home-video-blogs-wrapper")) {
  new PlayVideo;
}